import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { NugetType } from '@models';
import { urlStateHandler, } from '@pages/generics/grid';
import { NugetGridComponent } from './grids';
var ɵ0 = urlStateHandler;
var PackagesPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PackagesPageComponent, _super);
    function PackagesPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = NugetType.Packages;
        return _this;
    }
    PackagesPageComponent.prototype.ngOnInit = function () {
        this.createPermission = 'Packages.Create';
    };
    return PackagesPageComponent;
}(NugetGridComponent));
export { PackagesPageComponent };
export { ɵ0 };
